import React from 'react';
import PropTypes from 'prop-types';
import Interpolate from 'react-interpolate-component';

export default function InterpolateLinks({ template, render }) {
  const linkRegex = /(?:\[)(.+?)(?:\])(?:\(%\((.+?)\)s\))/g;
  const links = {};

  const templateString = template.replace(linkRegex, (_match, linkText, linkId) => {
    links[linkId] = render({ linkText, linkId });

    return `%(${linkId})s`;
  });

  return <Interpolate format={templateString} with={links} />;
}

InterpolateLinks.propTypes = {
  template: PropTypes.string.isRequired,
  render: PropTypes.func.isRequired,
};
